import * as Auth from '../actions/auth.actions'

export interface State {
  error: string | null
  pending: boolean
}

export const initialState: State = {
  error: null,
  pending: false,
}

export function reducer(state = initialState, action: Auth.AuthActions): State {
  switch (action.type) {

    case Auth.LOGIN: {
      return {
        ...state,
        error: null,
        pending: true,
      }
    }

    case Auth.LOGIN_SUCCESS: {
      return {
        ...state,
        error: null,
        pending: false,
      }
    }

    case Auth.LOGIN_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
      }
    }

    default: {
      return state
    }
  }
}

export const getError = (state: State) => state.error
export const getPending = (state: State) => state.pending



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/reducers/login-page.reducer.ts